import React, { Fragment } from "react";
import { connect } from "react-redux";
import ContactUs from "../components/ContactUs";
import { requestContact } from "../actions/deliveryAction";
import Spinner from "../components/layout/Spinner";

class ContactContainer extends React.Component {
  constructor(props) {
    super(props);

    // console.log(props);
  }
  componentDidMount() {
    this.props.requestContact(this.props.match.params.id);
  }
  render() {
    const { loading, delivery } = this.props;
    return (
      // <div className="container">
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <ContactUs
            id={delivery.id}
            name={delivery.shipto_first_name}
            merchant={delivery.shipfrom_name}
            email={delivery.customer_email}
            customer_support_email={delivery.customer_support_email}
            phone={delivery.phone}
            pickup={delivery.pickup}
            history={this.props.history}
            type="delivery_id"
          />
        )}
      </Fragment>
      // </div>
    );
  }
}
const mapStateToProps = (state) => ({
  delivery: state.requestContact.delivery,
  loading: state.requestContact.loading,
});
const mapDispatchToProps = (dispatch) => ({
  requestContact: (deliveryId) => dispatch(requestContact(deliveryId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ContactContainer);
